var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 40,
    height: 21.2507,
    viewBox: "0 0 40 21.2507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    d: "M29.3617 0.860653C30.6755 0.860653 31.9521 1.12097 33.1543 1.63099C34.3191 2.12507 35.3617 2.83166 36.266 3.7295C37.1649 4.62734 37.8723 5.67394 38.367 6.83741C38.8777 8.03808 39.1383 9.31312 39.1383 10.6253C39.1383 11.9376 38.8777 13.2126 38.367 14.4133C37.8723 15.5768 37.1649 16.618 36.266 17.5212C35.367 18.419 34.3191 19.1256 33.1543 19.6197C31.9521 20.1297 30.6755 20.39 29.3617 20.39H10.6383C9.32447 20.39 8.04787 20.1297 6.84574 19.6197C5.68085 19.1256 4.6383 18.419 3.73404 17.5212C2.83511 16.6234 2.12766 15.5768 1.63298 14.4133C1.12234 13.2126 0.861702 11.9376 0.861702 10.6253C0.861702 9.31312 1.12234 8.03808 1.63298 6.83741C2.12766 5.67394 2.83511 4.63265 3.73404 3.7295C4.63298 2.83166 5.68085 2.12507 6.84574 1.63099C8.04787 1.12097 9.32447 0.860653 10.6383 0.860653H29.3617ZM29.3617 0H10.6383C4.78723 0 0 4.78141 0 10.6253C0 16.4693 4.78723 21.2507 10.6383 21.2507H29.3617C35.2128 21.2507 40 16.4693 40 10.6253C40 4.78141 35.2128 0 29.3617 0Z",
    fill: "#3C4043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayOutline);
export default __webpack_public_path__ + "static/media/google-pay-outline.8baa1490bce2d74af4f7e527f0f828fe.svg";
export { ForwardRef as ReactComponent };